// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2bCXS","content":"RecentSearches_content__3sZk8"};